import { render, staticRenderFns } from "./pointShopConfig.vue?vue&type=template&id=8e31d9c4&"
import script from "./pointShopConfig.vue?vue&type=script&lang=js&"
export * from "./pointShopConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e31d9c4')) {
      api.createRecord('8e31d9c4', component.options)
    } else {
      api.reload('8e31d9c4', component.options)
    }
    module.hot.accept("./pointShopConfig.vue?vue&type=template&id=8e31d9c4&", function () {
      api.rerender('8e31d9c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/pointActivity/pointShopConfig.vue"
export default component.exports